module.exports = "<app-loading [enabled]=\"submitted\"></app-loading>\n"


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/auto-login/auto-login.component.html
// module id = ../../../../../src/app/core/components/auto-login/auto-login.component.html
// module chunks = main